module.exports = __webpack_public_path__ + "static/media/arrow-blanca.c19d400b.svg";